import React from 'react';

/**
 * MW Stewart Construction logo
 * Custom asphalt-paving themed mark: a stylized road roller (compactor) 
 * with a paved road and dashed center line — instantly readable as a paving company.
 */
export default function Logo({ size = 44, variant = 'light' }) {
  // variant: 'light' = on white bg, 'dark' = on dark bg
  const bg = variant === 'dark' ? '#0f172a' : '#f59e0b';
  const fg = variant === 'dark' ? '#f59e0b' : '#0f172a';
  const road = variant === 'dark' ? '#1e293b' : '#0f172a';
  const dash = '#f59e0b';

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 64 64"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      aria-label="MW Stewart Construction"
    >
      {/* Rounded square background */}
      <rect x="0" y="0" width="64" height="64" rx="10" fill={bg} />

      {/* Paved road strip at bottom */}
      <rect x="4" y="46" width="56" height="12" rx="2" fill={road} />
      {/* Dashed center lane line */}
      <g fill={dash}>
        <rect x="8" y="51" width="6" height="2" rx="0.5" />
        <rect x="20" y="51" width="6" height="2" rx="0.5" />
        <rect x="32" y="51" width="6" height="2" rx="0.5" />
        <rect x="44" y="51" width="6" height="2" rx="0.5" />
        <rect x="56" y="51" width="4" height="2" rx="0.5" />
      </g>

      {/* Road roller (compactor) silhouette */}
      {/* Big front drum */}
      <circle cx="22" cy="42" r="10" fill={fg} />
      <circle cx="22" cy="42" r="6" fill={bg} />
      <circle cx="22" cy="42" r="2.4" fill={fg} />

      {/* Cabin / body */}
      <path
        d="M30 22 h16 a3 3 0 0 1 3 3 v10 a3 3 0 0 1 -3 3 h-3 v4 h-13 v-4 a4 4 0 0 1 -4 -4 v-8 a4 4 0 0 1 4 -4 z"
        fill={fg}
      />
      {/* Cabin window */}
      <rect x="33" y="25" width="13" height="7" rx="1.5" fill={bg} />

      {/* Roof / exhaust */}
      <rect x="44" y="17" width="3" height="6" rx="1" fill={fg} />

      {/* Small rear wheel */}
      <circle cx="50" cy="44" r="6" fill={fg} />
      <circle cx="50" cy="44" r="3" fill={bg} />
    </svg>
  );
}
